
export class TareaFilter {
  public titulo: string | null = null;
  public descripcion: string | null = null;
  public fechaModificacionDesde: Date | null = null;
  public fechaModificacionHasta: Date | null = null;
  public fechaAltaDesde: Date | null = null;
  public fechaAltaHasta: Date | null = null;
  public idsEstadoTarea: number[] | null = null;
  public idsTipoTarea: number[] | null = null;
  public idsTareaPadre: number[]| null  = null;
  public asignadoA: number[] | null = null;
  public creadoPor: number[] | null = null;
  public modificadoPor: number[] | null = null;
  public autorizadoPor: number[] | null = null;
  public prioridad: number | null = null;
  public nivelAvance: number | null = null;
  public notificado: boolean | null = null;
  public idExpediente!:number
}
